import { toast } from "react-toastify";
import Parse from "../../api/ApiConfig";
import { useSelector } from "react-redux";

// Lease utils.js
export const getLeasorName = (data) => {
	if (data?.admin || data?.productId?.admin) {
		return data?.admin || data?.productId?.admin;
	} else return "---";
};

export const getUserName = (data) => {
	if (data?.userId?.firstName) {
		return data?.userId?.firstName + " " + data?.userId?.lastName;
	} else if (data?.user?.firstName) {
		return data?.user?.firstName + " " + data?.user?.lastName;
	} else return "---";
};

// API utils functions
const requestHeaders = {
	"X-Parse-Application-Id": "FortCore",
};

export const getChartData = async () => {
	try {
		const url = process.env.REACT_APP_SERVER_URL + "/functions/getLeaseInfo";
		// Fetch data from server
		const response = await fetch(url, {
			method: "POST",
			headers: requestHeaders,
		});

		const res = await response.json();
		if (res.error) {
			return res;
		} else {
			return res;
		}
	} catch (error) {
		return error;
	}
};

// Fetch lease table data (ongoing, submitted, completed, created_assets, savings)
export const fetchLeaseTable = async (category, filter) => {
	try {
		if (category) {
			let url = process.env.REACT_APP_SERVER_URL + "/functions/";
			// update url based on category
			switch (category) {
				case "ongoing":
					url += "ongoingLease";
					break;
				case "submitted":
					url += "requestedLease";
					break;
				case "completed":
					url += "completedLease";
					break;
				case "asset_registration":
					url += "completedLease";
					break;
				case "insurance":
					url += "completedLease";
					break;
				case "created_assets":
					url += "getInvestorAssets";
					break;
				case "savings":
					url += "getSavings";
					break;
				case "inactive":
					url += "getInactiveAssets";
					break;
				case "active":
					url += "getActiveAssets";
					break;
				case "funded":
					url += "getFundedAssets";
					break;
				default:
					return [];
			}

			// Fetch data from server
			const response = await fetch(url, {
				method: "POST",
				headers: requestHeaders,
				body: JSON.stringify({
					queryType:
						filter === "asset_registration"
							? "personal_business"
							: filter === "insurance"
							? "personal_business"
							: filter,
				}),
			});
			const data = await response.json();
			console.log(category, filter, data.result);

			const newData = data.result?.sort(
				(leaseOne, leaseTwo) =>
					new Date(leaseTwo?.createdAt)?.getTime() - new Date(leaseOne?.createdAt)?.getTime()
			);

			return data ? newData : [];
		} else return null;
	} catch (error) {
		console.log(error);
		return null;
	}
};

// Fetch single Lease object
export const fetchLeaseObject = async (leaseId) => {
	try {
		if (leaseId) {
			const url = process.env.REACT_APP_SERVER_URL + "/functions/viewLease";
			// Fetch data from server
			const response = await fetch(url, {
				method: "POST",
				body: JSON.stringify({ leaseId }),
				headers: requestHeaders,
			});

			const data = await response.json();
			console.log(leaseId, data);
			return !data.error ? data : { error: data.error };
		} else {
			return { error: "Lease ID not specified" };
		}
	} catch (error) {
		console.log(error);
		return null;
	}
};

// Fetch single Created Asset object
export const fetchInvestorAsset = async (assetId, profileFilter) => {
	try {
		if (assetId) {
			let url = process.env.REACT_APP_SERVER_URL;
			if (profileFilter === "investor") {
				url += "/functions/getAssetById";
			} else if (profileFilter === "quick_lease") {
				url += "/functions/getAdminAssetById";
			} else return { error: "Invalid profile filter" };

			// Fetch data from server
			const response = await fetch(url, {
				method: "POST",
				body: JSON.stringify({ assetId }),
				headers: requestHeaders,
			});
			const data = await response.json();
			console.log(assetId, data);
			return !data.error ? data : { error: data.error };
		} else {
			return { error: "Asset ID not specified" };
		}
	} catch (error) {
		console.log(error);
		return null;
	}
};

// Fetch single Savings object
export const fetchSavingsObject = async (objectId) => {
	try {
		if (objectId) {
			const url = process.env.REACT_APP_SERVER_URL + "/functions/getSavingById";
			// Fetch data from server
			const response = await fetch(url, {
				method: "POST",
				body: JSON.stringify({ objectId }),
				headers: requestHeaders,
			});
			const data = await response.json();
			console.log(objectId, data);
			return !data.error ? data : { error: data.error };
		} else {
			return { error: "Object ID not specified" };
		}
	} catch (error) {
		console.log(error);
		return null;
	}
};

export const fetchFilteredProduct = async (productData) => {
	try {
		const url = process.env.REACT_APP_SERVER_URL + "/functions/filterProducts";
		// Fetch data from server
		const response = await fetch(url, {
			method: "POST",
			body: JSON.stringify(productData),
			headers: requestHeaders,
		});
		const data = await response.json();
		// console.log(data);
		return data ? data.result : [];
	} catch (error) {
		console.log(error);
		return null;
	}
};

export const createAssetLease = async (formData) => {
	try {
		const url = process.env.REACT_APP_SERVER_URL + "/functions/createAdminAsset";
		// Fetch data from server
		const response = await fetch(url, {
			method: "POST",
			body: JSON.stringify(formData),
			headers: { ...requestHeaders, "X-Parse-Session-Token": Parse.User.current().getSessionToken() },
		});
		const data = await response.json();
		return data ? data.result : [];
	} catch (error) {
		console.log(error);
		return null;
	}
};

export const createAssetLeaseCopy = async (formData) => {
	console.log(formData);
	const Asset = Parse.Object.extend("Asset");
	const asset = new Asset();
	const response = await asset.save(formData);

	return response;
};

// Activate asset
export const activateAsset = async (formData) => {
	try {
		const url = process.env.REACT_APP_SERVER_URL + "/functions/activateAsset";
		// Fetch data from server
		const response = await fetch(url, {
			method: "POST",
			body: JSON.stringify(formData),
			headers: { ...requestHeaders, "X-Parse-Session-Token": Parse.User.current().getSessionToken() },
		});
		const data = await response.json();
		return data;
	} catch (error) {
		console.log(error);
		return null;
	}
};

export const createPin = async (pin) => {
	try {
		const currentUser = Parse.User.current();
		// Update access pin
		currentUser.set("accessPin", pin);
		await currentUser.save();
		return currentUser;
	} catch (error) {
		console.log(error);
		return null;
	}
};

export const updateAdminCreatedAsset = async (assetId, data) => {
	try {
		const query = new Parse.Query("Asset");
		const object = await query.get(assetId);
		const updatedObject = await object.save(data);

		return updatedObject?.toJSON();
	} catch (error) {
		console.log(error);
		toast.error("Failed to activate asset");
	}
};

export const handleAdminUpdateLease = async (leaseId, data) => {
	try {
		const query = new Parse.Query("Lease");
		const object = await query.get(leaseId);
		const updatedObject = await object.save(data);

		return updatedObject;
	} catch (error) {
		if (error?.message === "Failed to fetch") {
			toast.error("Oops. You are not connected to the internet.");
		} else {
			toast.error("Failed to approve lease request");
		}
	}
};

export const getApprovalStatus = (leaseData, requestStatus) => {
	const location = window.location.search;

	const approvedReq = requestStatus?.investor?.filter((a) => a?.status === "approved");
	const rejectedReq = requestStatus?.investor?.filter((a) => a?.status === "rejected");

	if (leaseData?.businessType) {
		return leaseData?.approvalStatus;
	}

	if (location === "?filter=quick_lease" || location === "?filter=investor") {
		return leaseData?.status;
	}

	if (leaseData?.state === "ongoing") {
		return leaseData?.approvalStatus;
	}

	if (leaseData?.leaseType === "Quick Lease") {
		return leaseData?.approvalStatus;
	}

	if (leaseData?.leaseType === "Sponsored Lease" && leaseData?.leaseSource === "products-catalogue") {
		return leaseData?.approvalStatus;
	}

	if (leaseData?.investorsArray?.length < 2) {
		return requestStatus?.status;
	} else if (leaseData?.investorsArray?.length === 2) {
		if (approvedReq?.length + rejectedReq?.length === 2) {
			if (approvedReq?.length > rejectedReq?.length) {
				return "approved";
			} else if (approvedReq?.length === rejectedReq?.length) {
				return "undecided";
			} else {
				return "rejected";
			}
		} else {
			return "pending";
		}
	} else if (leaseData?.investorsArray?.length === 3) {
		if (approvedReq?.length + rejectedReq?.length > 1) {
			if (approvedReq?.length > rejectedReq?.length) {
				return "approved";
			} else if (approvedReq?.length < rejectedReq?.length) {
				return "rejected";
			} else {
				return "pending";
			}
		} else {
			return "pending";
		}
	} else if (leaseData?.investorsArray?.length === 4) {
		if (approvedReq?.length + rejectedReq?.length > 2) {
			if (approvedReq?.length > rejectedReq?.length) {
				return "approved";
			} else if (approvedReq?.length < rejectedReq?.length) {
				return "rejected";
			} else if (approvedReq?.length === rejectedReq?.length) {
				return "undecided";
			} else {
				return "pending";
			}
		} else {
			return "pending";
		}
	}
};

export const getSubmittedQuickLease = async () => {
	const leaseClass = Parse.Object.extend("Lease");
	const query = new Parse.Query(leaseClass);

	query.equalTo("state", "requested");
	const response = await query.find();

	const data = response.map((item) => item.toJSON());

	console.log(data);

	const quickLeaseRequests = data?.filter(
		(request) => request?.leaseType?.includes("Quick") && request?.leaseSource?.includes("market")
	);

	return quickLeaseRequests;
};

export const onAdminUpdatesRequestStatus = async (assetId, assetData, newData) => {
	console.log(assetId, assetData, newData);
	try {
		const queryOne = new Parse.Query("Asset");
		const objectOne = await queryOne.get(assetId);
		const updatedObjectOne = await objectOne.save(assetData);

		console.log(updatedObjectOne);

		// Create a query to fetch objects based on your criteria
		const query = new Parse.Query("Lease");
		query.containedIn(
			"objectId",
			newData.map((obj) => obj?.id)
		);

		const objects = await query.find();

		console.log(objects);

		// Update each object with new data
		const updatedObjects = objects.map((parseObject, index) => {
			return parseObject.save(newData[index]);
			// parseObject.set("investorsArray", newData[index].investorsArray);
			// parseObject.set("usersRequest", newData[index].usersRequest);
			// return parseObject.save();
		});

		// Wait for all updates to complete
		const dataTwo = await Promise.all(updatedObjects);

		return {
			asset: updatedObjectOne?.toJSON(),
			leaseArr: dataTwo,
		};
	} catch (error) {
		console.log(error);
		if (error?.message?.includes("Unable to connect to the Parse API")) {
			toast.error("Oops! You are not conected to the internet");
			throw Error(error);
		} else {
			toast.error("Failed to update request status");
			throw Error(error);
		}
	}
};

export const fetchLeaseData = async () => {
	try {
		const leaseClass = Parse.Object.extend("Lease");
		const query = new Parse.Query(leaseClass);
		query.exists("leaseAgreement");

		const response = await query.find();

		const getFullData = response.map(async (item) => {
			const product = await item?.get("productId").fetch();

			const productJSON = product.toJSON();
			const dataJSON = item.toJSON();

			return {
				...dataJSON,
				productId: productJSON,
			};
		});

		const dataPromise = await Promise.allSettled(getFullData);
		const dataResolved = dataPromise.map((v) => v.value);

		const sortedData = dataResolved?.sort(
			(assetOne, assetTwo) =>
				new Date(assetTwo?.createdAt).getTime() - new Date(assetOne?.createdAt).getTime()
		);

		return sortedData;
	} catch (error) {
		toast.error("Failed to fetch");
	}
};

export const getInvestorName = (formData) => {
	const { companyInsuranceInfo } = useSelector((state) => state.app);
	const name = `${companyInsuranceInfo?.companyInsuranceInfo?.firstName} ${companyInsuranceInfo?.companyInsuranceInfo?.lastName}`;

	if (formData?.leaseType === "Quick Lease") {
		return companyInsuranceInfo ? name : "---";
	} else if (formData?.investors?.length > 1) {
		return companyInsuranceInfo ? name : "---";
	} else if (formData?.vehicleRegDetails) {
		return formData?.vehicleRegDetails?.investorName;
	} else {
		return "---";
	}
};

export const getInvestorEmail = (formData) => {
	const { companyInsuranceInfo } = useSelector((state) => state.app);
	const email = companyInsuranceInfo?.companyInsuranceInfo?.email;

	if (formData?.leaseType === "Quick Lease") {
		return companyInsuranceInfo ? email : "---";
	} else if (formData?.investors?.length > 1) {
		return companyInsuranceInfo ? email : "---";
	} else if (formData?.vehicleRegDetails) {
		return formData?.vehicleRegDetails?.investorEmail;
	} else {
		return "---";
	}
};

export const investorRegisterAsset = async (dataToUpdate) => {
	try {
		const response = await fetch(`${Parse.serverURL}/functions/getWalletDetails`, {
			method: "POST",
			body: JSON.stringify(dataToUpdate),
			headers: {
				"X-Parse-Application-Id": process.env.REACT_APP_APP_ID,
				"X-Parse-Session-Token": Parse.User.current().getSessionToken(),
			},
		});

		const data = await response.json();

		return data;
	} catch (error) {
		console.log(error);
		if (error?.message === "Failed to fetch") {
			toast.error("You are not connected to the internet.");
		} else if (error?.message.includes("Invalid session token")) {
			localStorage.clear();
			toast.error("This session has expired. Please Login again");
			window.location.href = "/login";
		} else {
			toast.error(error);
		}
	}
};

export const getCurrentDate = () => {
	const currentDate = new Date();

	// Extract year, month, and day components
	const year = currentDate.getFullYear();
	const month = String(currentDate.getMonth() + 1).padStart(2, "0"); // Month is zero-based
	const day = String(currentDate.getDate()).padStart(2, "0");

	// Form the yyyy-mm-dd format
	const formattedDate = `${year}-${month}-${day}`;

	return formattedDate;
};

export const removeCountryCode = (phone) => {
	const firstChar = phone?.charAt(0);
	return firstChar === "0" ? phone : `0${phone?.slice(3)}`;
};

export const getIdType = (idType) => {
	if (idType?.includes("National Identity")) {
		return "nimc";
	} else if (idType?.includes("International")) {
		return "internationalPassport";
	} else if (idType?.includes("Voter")) {
		return "votersCard";
	} else if (idType?.includes("Driver")) {
		return "driversLicense";
	} else {
		return "others";
	}
};

export function convertDateFormat(inputDate) {
	// Split the input date string into day, month, and year
	const [day, month, year] = inputDate.split("-");

	// Create a new Date object with the parsed values
	const originalDate = new Date(year, month - 1, day);

	// Get the ISO date string in "YYYY-MM-DD" format
	const isoDateString = originalDate.toISOString().split("T")[0];

	return isoDateString;
}

export const investorApplyForInsurance = async (dataToSubmit) => {
	try {
		const url = process.env.REACT_APP_SERVER_URL + "/functions/carInsurance";

		const response = await fetch(url, {
			method: "POST",
			body: JSON.stringify(dataToSubmit),
			headers: { ...requestHeaders, "X-Parse-Session-Token": Parse.User.current().getSessionToken() },
		});
		const data = await response.json();

		if (data?.error) {
			throw data?.error;
		} else {
			return data?.result;
		}
	} catch (error) {
		console.log(error);
		if (error?.message === "Failed to fetch") {
			toast.error("Oops. You are not connected to the internet");
		} else if (error?.message?.includes("Invalid session token")) {
			localStorage.clear();
			toast.error("This session has expired. Please Login again");
			window.location.href = "login";
		} else if (error) {
			toast.error(error);
		} else {
			toast.error("Failed to insure asset");
		}
	}
};

export const getVehicleType = (type) => {
	switch (type) {
		case "Suv":
			return "SUV";
		default:
			"Saloon";
	}
};

export function reverseDate(inputDate) {
	// Split the input date into day, month, and year
	var parts = inputDate.split("-");

	// Rearrange the parts to form the new date format (YYYY-MM-DD)
	var newDateFormat = parts[2] + "-" + parts[1] + "-" + parts[0];
	if (parts[0]?.length === 4) {
		return inputDate;
	} else {
		return newDateFormat;
	}
}
export const getProductsObjects = (product) => {
	return {
		id: product?.objectId,
		amount: product?.amount,
		brand: product?.brand,
		model: product?.model,
		category: product?.category,
		color: product?.color,
		description: product?.description,
		keyFeatures: product?.keyFeatures,
		pickupAddress: product?.pickupAddress,
		productName: product?.productName,
		shelfLife: product?.shelfLife,
		specifications: product?.specifications,
		subCategory: product?.subCategory,
		tags: product?.tags,
		year: product?.year,
		imageArr: [product?.image, product?.secondImage, product?.thirdImage].filter(
			(image) => image !== undefined
		),
		objectId: product?.objectId,
		condition: product?.condition || "brand new",
	};
};
